module.exports = __webpack_public_path__ + "static/media/woman-sitting-laptop.f8ca2dfb.svg";